<template>
    <button :type="type" :value="value" :ariaType="ariaType" :disabled="currentlyDisabled" :class="{'loading': loading}" v-on="$listeners" class="btn">
        <slot></slot>
    </button>
</template>

<script type="text/javascript">
export default {
    name: "LoadingButton",
    computed: {
        currentlyDisabled () {
            return this.disabled || this.loading
        }
    },
    methods: {
        toggle_loading () {
            if(this.loading) this.stop_loading()
            else this.start_loading()
        },
        start_loading () {
            this.loading = true
        },
        stop_loading () {
            this.loading = false
        }
    },
    props: {
        value: {
            type: String,
            default: ""
        },
        type: {
            type: String,
            default: "button"
        },
        ariaType: {
            type: String,
            default: ""
        },
        disabled: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            default: false
        }
    }
}
</script>
